export const INPUT_TYPE_TEXT = 'text';
export const INPUT_TYPE_CHECKBOX = 'checkbox';
export const INPUT_TYPE_EMAIL = 'email';
export const INPUT_TYPE_SELECT = 'select';
export const INPUT_TYPE_RADIO = 'radio';
export const INPUT_TYPE_DATE = 'date';
export const INPUT_TYPE_TIME = 'time';
export const INPUT_TYPE_PHONE_NUMBER = 'tel';
export const INPUT_TYPE_URL = 'url';
export const INPUT_TYPE_NUMBER = 'number';
export const INPUT_TYPE_ADDRESS = 'splashAddress';
export const INPUT_TYPE_FILE = 'file';
export const INPUT_TYPE_HIDDEN = 'hidden';
export const INPUT_TYPE_MULTI_SELECT = 'splashMultiselect';
export const INPUT_TYPE_PARAGRAPH = 'textarea';
export const INPUT_TYPE_CAPTCHA = 'splashCaptcha';
export const INPUT_TYPE_EVENT_OPS_RESOURCE = 'splashEventOpsResource';
export const INPUT_TYPE_EVENT_OPS_2 = 'splashEventOps2';
export const INPUT_TYPE_SOCIAL_RSVP = 'splashSocialRsvp';
